'use client';

import { Link } from '@larvitu/shared/next/mui';
import { Typography } from '@mui/material';
import { forwardRef } from 'react';


import { useGetFontValue } from '../../..';

import type { LinkProps, TypographyProps } from '@mui/material';
import type { ReactNode } from 'react';

type IProps = TypographyProps & LinkProps;

interface TextMaxLineProps extends IProps {
  line?: number;
  asLink?: boolean;
  persistent?: boolean;
  children: ReactNode;
  variant?: TypographyProps['variant'];
}

export const TextMaxLine = forwardRef<HTMLAnchorElement, TextMaxLineProps>(
  function TextMaxLine(
    {
      asLink,
      variant = 'body1',
      line = 2,
      persistent = false,
      children,
      sx,
      ...other
    },
    ref
  ) {
    const { lineHeight } = useGetFontValue( variant );

    const style = {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: line,
      WebkitBoxOrient: 'vertical',
      ...(persistent && { height: lineHeight * line }),
      ...sx,
    } as const;

    if (asLink) {
      return (
        <Link
          color="inherit"
          ref={ref}
          variant={variant}
          sx={{ ...style }}
          {...other}
        >
          {children}
        </Link>
      );
    }

    return (
      <Typography ref={ref} variant={variant} sx={{ ...style }} {...other}>
        {children}
      </Typography>
    );
  }
);
